// extracted by mini-css-extract-plugin
export default {"wrapper":"CryptoTitle_wrapper__yUBFn","icon":"CryptoTitle_icon__Myr1J","title":"CryptoTitle_title__cF6MN","assetName":"CryptoTitle_assetName__9jAaC"};